import axios from "axios"
import Cookies from "js-cookie"
import { FIRMFLOWURL } from "./url";
export const createClient = (form) => {
    return new Promise(async resolve => {
        try {
            const clientPayload = { ...form };
            delete clientPayload.subscriptionType;
            delete clientPayload.isActive;
            delete clientPayload.subscriptionCancellationDate;
            delete clientPayload.inactiveReason;
            const token = Cookies.get('Bearer');
            const firm = await axios.get(`${FIRMFLOWURL}api/Firm`,
                {
                    headers: { 'Authorization': token }
                }
            )

            console.log(firm);

            const response = await axios.post(`${FIRMFLOWURL}api/Client/firm/${firm.data.id}`,
                {
                    ...clientPayload
                },
                {
                    headers: { 'Authorization': token }
                }
            )
            resolve({ message: response.data.message, success: true });
        } catch (err) {
            console.log(err)
            if(err.message.includes(401)){
                Cookies.remove('Bearer');
                window.location.replace('/');
                return;
            }
            resolve({ success: false, message: err.response.data.message });
        }
    })
}
